import * as React from 'react'
import { NextPage } from 'next'
import { PageProps } from '../../types'
import Meta from '../Meta'
import Header from '../Header'
import Footer from '../Footer'

type layoutProps = Pick<PageProps, 'headerHTML' | 'footerHTML' | 'partner'> & {
  children: React.ReactNode
}

const Layout: NextPage<layoutProps> = ({
  headerHTML,
  footerHTML,
  children,
  partner
}) => (
  <>
    <Meta {...(partner && { partner })} />
    <Header headerHTML={headerHTML} partner={partner} />
    {children}
    <Footer footerHTML={footerHTML} partner={partner} />
  </>
)

export default Layout
